/** FNV-1a, 32-bit. Fast, dependency-free, and stable across engines. */
export function fnv1a32(input) {
    let hash = 0x811c9dc5;
    for (let index = 0; index < input.length; index += 1) {
        hash ^= input.charCodeAt(index);
        // hash *= 16777619, in 32-bit arithmetic.
        hash = Math.imul(hash, 0x01000193) >>> 0;
    }
    return hash >>> 0;
}
/** The 32-bit seed a key resolves to. */
export function seedFrom(key) {
    return fnv1a32(`${key.runSeed}|${String(key.day)}|${key.phase}|${key.eventKey}`);
}
/**
 * mulberry32. One 32-bit word of state, a good enough distribution for picking
 * flavour text, and identical output in every JavaScript engine because every
 * step is explicit 32-bit integer arithmetic.
 */
function step(state) {
    const next = (state + 0x6d2b79f5) | 0;
    let t = Math.imul(next ^ (next >>> 15), 1 | next);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return { state: next, value: ((t ^ (t >>> 14)) >>> 0) / 4294967296 };
}
/**
 * The `index`-th float in `[0, 1)` drawn from `seed`, counting from zero.
 *
 * Indexed rather than stateful so callers stay pure: two calls with the same
 * arguments return the same number, always.
 */
export function floatAt(seed, index) {
    let state = seed | 0;
    let value = 0;
    for (let i = 0; i <= index; i += 1) {
        const drawn = step(state);
        state = drawn.state;
        value = drawn.value;
    }
    return value;
}
/** The `index`-th integer in `[0, bound)`. Returns `0` for a non-positive bound. */
export function intAt(seed, index, bound) {
    if (bound <= 0)
        return 0;
    return Math.floor(floatAt(seed, index) * bound) % bound;
}
/** The `index`-th draw from `items`, or `undefined` when there is nothing to draw. */
export function pickAt(items, seed, index) {
    if (items.length === 0)
        return undefined;
    return items[intAt(seed, index, items.length)];
}
/**
 * `count` draws from `items` without replacement, in draw order. Returns fewer
 * than `count` only when `items` is shorter.
 */
export function drawWithoutReplacement(items, seed, count) {
    const remaining = [...items];
    const drawn = [];
    for (let index = 0; index < count && remaining.length > 0; index += 1) {
        const [taken] = remaining.splice(intAt(seed, index, remaining.length), 1);
        if (taken !== undefined)
            drawn.push(taken);
    }
    return drawn;
}
//# sourceMappingURL=rng.js.map